import styled from "styled-components";
import tw, {
    classnames,
    borderColor,
    backgroundColor,
    padding,
    margin,
    display,
    borderRadius,
    cursor,
    transitionProperty,
    transitionDelay,
    transitionDuration,
    textColor,
} from "tailwindcss-classnames";

const optionItemBaseClass = classnames(
    padding("py-1", "px-2"),
    margin("mr-1", "my-0.5"),
    display("inline-block"),
    borderRadius("rounded-sm"),
    cursor("cursor-pointer"),
    transitionProperty("transition", "transition-all", "transition-transform"),
    transitionDelay("delay-100"),
    transitionDuration("duration-300"),
);

export const OptionItemAnchor = (id: string, selected = false) =>
    styled.a.attrs({
        className: classnames(
            optionItemBaseClass,
            !selected
                ? classnames(
                      textColor("hover:text-white" as any, "hover:dark:text-black" as any),
                      backgroundColor("bg-gpas-100" as any, "dark:bg-gpas-200" as any, "hover:bg-gpas-700" as any),
                      borderColor("hover:border-gpas-100" as any),

                  )
                : classnames(
                      backgroundColor("bg-gpas-700" as any),
                      borderColor("border-gpas-600" as any),
                      textColor("text-white" as any),
                  ),
            transitionDuration("duration-300"),
            transitionProperty("transition-colors"),
        ),
    })``;
